import {useQuery} from "@tanstack/react-query";
import {USER_ENDPOINTS} from "../../services/network/endpoints";
import {ReportAPI} from "../../services/network/report-api";

export function useFetchSubUsersByEmail(emails: Array<string>, userIsAdmin: boolean, isRoivUser: boolean, isMinzdravUser: boolean) {
    const {data, error, isLoading} = useQuery({
        queryKey: [USER_ENDPOINTS.FETCH_USER_BY_EMAIL, emails],
        queryFn: () => ReportAPI.fetchUsersByEmails({emails}),
        enabled: (userIsAdmin || isRoivUser || isMinzdravUser) && emails.length !== 0,
    });

    return {
        usersData: data?.data,
        usersError: error,
        usersIsLoading: isLoading,
    };
}